const rankings = [
  { rank: 1, title: '星际穿越2', type: '科幻', views: '128万', trend: 'up' },
  { rank: 2, title: '月光之恋', type: '韩剧', views: '106万', trend: 'up' },
  { rank: 3, title: '暗夜追踪 第四季', type: '美剧', views: '98万', trend: 'hot' },
  { rank: 4, title: '欢乐大本营', type: '综艺', views: '85万', trend: 'up' },
  { rank: 5, title: '龙之传说', type: '动画', views: '72万', trend: 'new' },
];

const rankColors = ['text-accent-500', 'text-primary-500', 'text-secondary-400', 'text-foreground-500', 'text-foreground-500'];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-8 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-400 bg-accent-500/10 rounded-full mb-3">
            实时排行
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热度排行榜
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">
            根据观看量实时更新的热门内容
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="rounded-lg bg-background-100 border border-background-200/60 overflow-hidden">
            {rankings.map((item, idx) => (
              <a
                key={item.rank}
                href="#cards"
                className={`flex items-center gap-4 px-5 py-4 hover:bg-background-200/50 transition-colors group ${
                  idx < rankings.length - 1 ? 'border-b border-background-200/40' : ''
                }`}
              >
                <span className={`w-8 h-8 flex items-center justify-center font-bold text-lg font-label ${rankColors[idx]}`}>
                  {item.rank < 10 ? `0${item.rank}` : item.rank}
                </span>

                <div className="flex-1 min-w-0">
                  <span className="text-sm font-medium text-foreground-800 group-hover:text-foreground-950 transition-colors">
                    {item.title}
                  </span>
                  <span className="ml-2 text-[11px] text-foreground-400">{item.type}</span>
                </div>

                <div className="flex items-center gap-2 text-xs text-foreground-400 whitespace-nowrap">
                  {item.trend === 'hot' && (
                    <span className="flex items-center gap-0.5 text-accent-500">
                      <i className="ri-fire-fill text-[10px]"></i>
                    </span>
                  )}
                  {item.trend === 'new' && (
                    <span className="flex items-center gap-0.5 text-primary-500">
                      <i className="ri-sparkling-fill text-[10px]"></i>
                    </span>
                  )}
                  {item.trend === 'up' && (
                    <span className="flex items-center gap-0.5 text-secondary-400">
                      <i className="ri-arrow-up-fill text-[10px]"></i>
                    </span>
                  )}
                  <span>{item.views}次播放</span>
                </div>

                <span className="text-foreground-300 group-hover:text-primary-400 transition-colors">
                  <i className="ri-arrow-right-s-line text-sm"></i>
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}